// externals
import React from 'react';

// libraries
import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';
import type { DealHistory } from '@makemydeal/dr-dash-types';
import * as compositeSelectors from '@makemydeal/dr-dash-store/selectors/compositeSelectors';

// consts
import * as constants from '../../constants';

// components
import DealSummaryItem from '../common/DealSummaryItem';

// hooks
import { createDealRootSelector } from '../../offerCompareColumn/hooks/createDealRootSelector';
import { useDealSummary } from '../../common/DealSummaryProvider';

// styles
import { detailedViewValueStyles } from '../utils/styles';

const NetSellingPrice = ({ deal, hasDelta = false }: { deal?: DealHistory; hasDelta?: boolean }) => {
    const useDealRootSelector = createDealRootSelector(deal, 'NetSellingPrice');
    const netSellingPrice = useDealRootSelector(compositeSelectors.getNetSellingPrice, 'netSellingPrice');
    const { showDetailedView } = useDealSummary();
    const formattedNetSellingPrice = netSellingPrice || 0;

    return (
        <DealSummaryItem
            label={constants.NET_SELLING_PRICE}
            value={formatDollarsAndCents(formattedNetSellingPrice)}
            hasDelta={hasDelta}
            valueStyles={showDetailedView ? detailedViewValueStyles : {}}
        />
    );
};

export default NetSellingPrice;
